export default new class {
  constructor() {
    this.favListContainer = '.favorites__container'
    this.favBtnList = document.querySelectorAll('.fav-btn')

    if (this.favBtnList.length > 0) this.initFavBtn()

    // this.init()
  }

  init() {
    $.request('FavoriteArticle::onShowFavoriteArticle', {
      data: {},
      update: {
        'project/common/favorites/favorites': this.favListContainer,
      },
      complete: (result) => {
        //console.log(result);
      },
    });
  }

  initFavBtn() {
    this.favBtnList.forEach(favBtn => {
      favBtn.onclick = (e) => {
        console.log(e.target.classList.contains('added'))
        const tooltip = e.target.nextElementSibling;
        if (!e.target.classList.contains('added')) {
          if (e.target.dataset.id) {
            if (e.target.classList.contains('single')) {
              e.target.classList.add('added');
            } else {
              this.favBtnList.forEach(btn => {
                btn.classList.add('added');
              })
            }
            if (tooltip && tooltip.classList.contains('tooltip__text')) {
              tooltip.innerText = 'Удалить из избранного';
            }
            this.__addToFav(e.target.dataset.id)
          }
        } else {
          if (e.target.dataset.id) {
            if (e.target.classList.contains('single')) {
              e.target.classList.remove('added')
            } else {
              this.favBtnList.forEach(btn => {
                btn.classList.remove('added');
              })
            }

            if (tooltip && tooltip.classList.contains('tooltip__text')) {
              tooltip.innerText = 'Добавить в избранное';
            }
            this.__deleteFromFav(e.target.dataset.id)
          }
        }
      }
    })
  }


  __addToFav(articleId) {
    console.log('add')
    $.request('FavoriteArticle::onAddFavoriteArticle', {
      data: {
        articleId:articleId
      },
      complete: (result) => {
        console.log(result);
      },
    });
  }

  __deleteFromFav(articleId) {
    console.log('delete')
    $.request('FavoriteArticle::onDeleteFavoriteArticle', {
      data: {
        articleId:articleId
      },
      complete: (result) => {
        console.log(result);
      },
    });
  }
}()
